const BaseEntry = require('./BaseEntry');
const getConstants = require('../../../utils/getConstants');
const constants = getConstants();
const { answerStates } = constants;

class CalculatedEntry extends BaseEntry {
   constructor(aggregateRoot, componentData, items, entries, ruleEvaluator) {
      super(aggregateRoot, componentData, items, entries, ruleEvaluator);
   }

   materialize({ actionedOn }) {
      const item = this.item;
      const noResponse = item.response ? item.response.no : 1;

      const val =
         this._resolver && typeof this._resolver.getDisplayValue === 'function'
            ? this._resolver.getDisplayValue(this.idItem)?.value ?? null
            : null;

      // optional: skip blank values
      if (val == null || String(val).trim() === '') return;

      const newItemState = (item.state || 0) | answerStates.ANSWERED;

      const p = {
         idItem: this.idItem,
         state: newItemState,
         actionedOn,
         noResponse,
         val: String(val),
         noSubmissionItem: item.no,
         noSubmission: this._aggregateRoot.getSubmissionNo()
      };

      this.apply('CALCULATED_FIELD_MATERIALIZED', p);

      item.response = item.response || {};
      item.response.no = noResponse;
      item.response.val = String(val);
      item.response.upd = actionedOn;
      item.state = newItemState;
      item.upd = actionedOn;
   }

   lock() {
      const item = this.item;
      const { state } = item;
      item.state = state | answerStates.LOCKED;
   }

   unlock() {
      const item = this.item;
      const { state } = item;
      item.state = state & ~answerStates.LOCKED;
   }

   validate() {
      return true;
   }

   getFriendlyValue() {
      const item = this.item;
      const value = item.response && item.response.val !== undefined ? item.response.val : '';
      return value;
   }
}

module.exports = CalculatedEntry;
